import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  ManagementApiService,
  SubListParams,
  SubscriptionResponse,
} from 'features/management-report/api/management-api.service';
import qs from 'qs';

import { ManagemntQueryKeys } from './query-keys';
const { getManagementReport } = ManagementApiService();

const getUsersQuery = (
  params: SubListParams,
  options?: UseQueryOptions<SubscriptionResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<SubscriptionResponse>;
  options?: UseQueryOptions<SubscriptionResponse>;
} => ({
  queryKey: ManagemntQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getManagementReport(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetManagementReportList = (
  params: any,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
